module.exports = {"id":"230183","name":"Gazzolisco","rating":"77","photo":"./data/images/photos/3/230183.png","club":{"name":"Cruzeiro","logo":"./data/images/clubs/Cruzeiro.png"},"positions":["DG","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Gazzolisco0.json
// module id = 1544
// module chunks = 0